var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-fallback insicht insicht--fade-up" },
    [
      _c(
        "form",
        {
          staticClass: "payment-fallback__wrapper",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _vm.title
            ? _c("h2", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                staticClass: "payment-fallback__title"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.subtitle
            ? _c("h3", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.subtitle,
                    expression: "subtitle"
                  }
                ],
                staticClass: "payment-fallback__subtitle"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.response.message
            ? _c("GeneralMessage", {
                ref: "message",
                attrs: {
                  message: _vm.response.message,
                  type: _vm.response.type,
                  stick: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ValidationProvider", {
            staticClass: "payment-fallback__location",
            attrs: {
              name: "location",
              rules: "required",
              tag: "div",
              customMessages: { required: _vm.$t("forms.errors.fieldEmpty") }
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  var invalid = ref.invalid
                  var validated = ref.validated
                  var dirty = ref.dirty
                  return [
                    _c("FormInputSelect", {
                      attrs: {
                        options: _vm.locationOptions,
                        label: _vm.$t("paymentfallback.locationLabel"),
                        disabled: _vm.formLocked,
                        required: ""
                      },
                      on: { input: _vm.onChannelSelect },
                      model: {
                        value: _vm.channel,
                        callback: function($$v) {
                          _vm.channel = $$v
                        },
                        expression: "channel"
                      }
                    }),
                    _vm._v(" "),
                    invalid && validated
                      ? _c("span", {
                          staticClass: "input-error",
                          domProps: { innerHTML: _vm._s(errors[0]) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.location
                      ? _c("OrderBoxLocation", {
                          attrs: {
                            location: _vm.formatLocation(_vm.location),
                            "shipping-method": "takeaway",
                            "no-click": ""
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "payment-fallback__amount" }, [
            _c("span", {
              staticClass: "payment-fallback__amount-prefix",
              domProps: { innerHTML: _vm._s("CHF") }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.amount,
                  expression: "amount",
                  modifiers: { number: true }
                }
              ],
              staticClass: "payment-fallback__amount-input",
              attrs: {
                type: "number",
                min: "0",
                step: "0.05",
                disabled: _vm.formLocked,
                required: ""
              },
              domProps: { value: _vm.amount },
              on: {
                blur: [
                  _vm.onBlur,
                  function($event) {
                    return _vm.$forceUpdate()
                  }
                ],
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.amount = _vm._n($event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("Button", {
            attrs: {
              type: "submit",
              level: "primary",
              text: _vm.$t("paymentfallback.orderButton"),
              disabled: _vm.submitLocked
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }